import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2929 8.29283C11.6834 7.90231 12.3166 7.90231 12.7071 8.29283L18.364 13.9497C18.7545 14.3402 18.7545 14.9733 18.364 15.3639C17.9734 15.7544 17.3403 15.7544 16.9497 15.3639L12 10.4141L7.05025 15.3639C6.65973 15.7544 6.02656 15.7544 5.63604 15.3639C5.24551 14.9733 5.24551 14.3402 5.63604 13.9497L11.2929 8.29283Z"
	})
});
export default SvgUpLine;
